import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MessagingProvider } from '@shared/sms/enums';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-whatsapp-toggle',
  templateUrl: './whatsapp-toggle.component.html',
  styleUrls: ['./whatsapp-toggle.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WhatsappToggleComponent),
      multi: true,
    },
  ],
})
export class WhatsappToggleComponent implements ControlValueAccessor {
  icon = AppIcon;
  whatsappEnabled = false;
  disabled = false;

  private currentProvider?: MessagingProvider | null;
  private initialProvider?: MessagingProvider | null;
  private onChange?: (value?: MessagingProvider | null) => unknown;
  private onTouched = () => {};

  toggle(): void {
    this.whatsappEnabled = !this.whatsappEnabled;
    this.writeValue(this.whatsappEnabled ? MessagingProvider.whatsApp : this.initialProvider);
    if (this.onChange) {
      this.onChange(this.currentProvider);
    }
  }

  registerOnChange(onChangeMethod: () => unknown): void {
    this.onChange = onChangeMethod;
  }

  registerOnTouched(onTouchedMethod: () => unknown): void {
    this.onTouched = onTouchedMethod;
  }

  writeValue(provider: MessagingProvider | null | undefined): void {
    this.currentProvider = provider;
    if (this.initialProvider === undefined) {
      this.initialProvider = this.currentProvider === MessagingProvider.whatsApp ? null : this.currentProvider;
    }

    this.whatsappEnabled = this.currentProvider === MessagingProvider.whatsApp;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
